import { Injectable } from '@angular/core';
import { SpinnerComponent } from './spinner.component';

@Injectable()
export class SpinnerService {

  private spinnerCache = new Set<SpinnerComponent>();

  // tslint:disable-next-line:no-empty
  constructor() { }

  _register(spinner: SpinnerComponent): void {
    this.spinnerCache.add(spinner);
  }
  _unregister(spinner: SpinnerComponent): void {
    this.spinnerCache.forEach(// tslint:disable-next-line:no-shadowed-variable
      (spinner) => {
        this.spinnerCache.delete(spinner);
      });
  }

  show(spinnerName: string): void {
    this.spinnerCache.forEach(
      (spinner) => {
      if (spinner.name === spinnerName) {
        spinner.show = true;
      }
    });
  }

  hide(spinnerName: string): void {
    this.spinnerCache.forEach(
      (spinner) => {
        if (spinner.name === spinnerName) {
          spinner.show = false;
      }
    });
  }
}
